<template>
  <!-- eslint-disable vue/no-v-html -- markdown-it escapes raw HTML, see MARKDOWN -->
  <div
    class="release-markdown"
    v-html="markdownAsHtml"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script setup lang="ts">
import MarkdownIt from 'markdown-it';
import {
  computed,
} from 'vue';

const props = defineProps<{
  markdown: string,
}>();

const MARKDOWN = new MarkdownIt({
  html: false,
});

// Links lead away from the app, e.g. to the user manual or a video, so they open in a new tab
// instead of replacing Qmulus.
MARKDOWN.renderer.rules.link_open = (tokens, index, options, _environment, renderer) => {
  tokens[index].attrSet('target', '_blank');
  tokens[index].attrSet('rel', 'noopener noreferrer');
  return renderer.renderToken(tokens, index, options);
};

const markdownAsHtml = computed<string>(() => MARKDOWN.render(props.markdown));
</script>

<style scoped lang="scss">
.release-markdown {
  line-height: 1.5;

  :deep(h3),
  :deep(h4) {
    font-weight: bold;
    margin-top: var(--gap-section);
  }

  :deep(h3:first-child) {
    margin-top: 0;
  }

  :deep(p + p),
  :deep(ul),
  :deep(ol) {
    margin-top: var(--gap-union);
  }

  :deep(li ul),
  :deep(li ol) {
    margin-top: 0;
  }

  :deep(ul) {
    list-style: disc;
    padding-left: 1.5rem;
  }

  :deep(ol) {
    list-style: decimal;
    padding-left: 1.5rem;
  }

  :deep(strong) {
    font-weight: bold;
  }

  :deep(em) {
    font-style: italic;
  }

  :deep(code) {
    font-family: monospace;
  }

  :deep(a) {
    color: var(--primary-color);
    text-decoration: underline;
  }
}
</style>
